import { AdaBindMethodPipe } from '@adaptiva/core/common';
import { ClickableComponentModule } from '@adaptiva/widgets/clickable';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CveDisplayAnchorComponent } from './cve-display-anchor.component';

const _widgets = [
	ClickableComponentModule,
	TextComponentModule
];

@NgModule({
	imports: [
		_widgets,
		AdaBindMethodPipe,
		CommonModule
	],
	declarations: [
		CveDisplayAnchorComponent
	],
	exports: [
		CveDisplayAnchorComponent
	]
})
export class CveDisplayAnchorComponentModule {

}
